//library
import { useMemo, useState, useCallback, useEffect } from "react";

// store
import { useAppSelector } from "store/store";

import useWindowSize from "hooks/use-window-size";

//components
import AppNavbar from "components/app-navbar";
import HeaderCard from "components/app-header-card";
import AppPagination from "components/app-pagination";

import headerImage from "assets/images/pages/page-products/products-bg.jpg";
import AppProductCard from "components/app-product-card";

import AppFooter from "components/app-footer";
import SEO from "components/app-seo";
import StructuredData from "components/app-structured-data";

// config
import { getPageSEO, isLanguageSupported, seoConfig } from "config/seo-config";
import { DEFAULT_LANGUAGE } from "config/language-config";

const PageProducts = () => {
	const { current } = useAppSelector((state) => state.language);
	const lang = (current || DEFAULT_LANGUAGE) as "en" | "th";

	// const seoData = pageSEO.productListing[lang];
	const seoData = getPageSEO("home", isLanguageSupported(lang) ? lang : DEFAULT_LANGUAGE);

	const alternateLanguages = [
		{ lang: "x-default", url: "https://www.altecflex.com/product-listing" },
		{ lang: "en", url: "https://www.altecflex.com/product-listing" },
		{ lang: "th", url: "https://www.altecflex.com/th/product-listing" },
	];

	const canonical = lang === "th" ? "https://www.altecflex.com/th/product-listing" : "https://www.altecflex.com/product-listing";

	const sizes = useWindowSize();
	const [currentPage, setCurrentPage] = useState(0);
	const isMobileView = useMemo(() => (sizes?.[0] <= 489 ? true : false), [sizes]);
	const content = useMemo(() => {
		return [
			{
				title: "AI Financial Planner (Wealth Management)",
				description: "Customer Web, Admin Back-office Portal",
				videoUrl: "https://media.directintegrate.com/altecflex/video/ATF-Wealth-Management-System.mp4",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/WMS-Thumbnail.jpg",
			},
			{
				title: "E-Invoice",
				description: "Customer Responsive Web, Admin Back-office Portal",
				videoUrl: "https://media.directintegrate.com/altecflex/video/ATF-E-Invoice.mp4",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/E-Invoice-Thumbnail.jpg",
			},
			{
				title: "Work Order Management System",
				description: "Customer Mobile App, Admin Back-office Portal​",
				videoUrl: "https://media.directintegrate.com/altecflex/video/ATF-Work-Order-Management-System.mp4",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/WOMS-Thumbnail.jpg",
			},
			{
				title: "Content Management System + e-Commerce (Lite)",
				description: "Website, Buyer Web, Seller Web, Admin Back-office Portal​",
				videoUrl: "https://cdn.directintegrate.com/directintegrate/media/video/ATF-E-Commerce-Lite-Video.mp4",
				link: "https://media.directintegrate.com/directintegrate/cms/brochure/ATF-E-Commerce-Brochure.pdf",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/CMS_Lite-Thumbnail.jpg",
			},
			{
				title: "Content Management System + e-Commerce (Full Suite)",
				description: "Website, Buyer App, Seller App, Buyer Web, Seller Web, Admin Back-office Portal​",
				videoUrl: "https://media.directintegrate.com/altecflex/video/ATF-E-commerce-Video.mp4",
				link: "https://media.directintegrate.com/directintegrate/cms/brochure/ATF-E-Commerce-Brochure.pdf",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/CMS_Suite-Thumbnail.jpg",
			},
			{
				title: "Retail Business Management System",
				description: "Customer Web, Admin Back-office Portal",
				videoUrl: "http://cdn.directintegrate.com/directintegrate/media/video/ATF-RBMS-Video_V2.mp4",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/RBMS-Thumbnail.jpg",
			},
			{
				title: "Insurance Brokerage Management System",
				description: "Agent Web, Admin Back-office Portal, SFTP",
				videoUrl: "http://cdn.directintegrate.com/directintegrate/media/video/ATF General Insurance Admin Portal Video.mp4",
				link: "https://media.directintegrate.com/directintegrate/cms/brochure/ATF_IMS_Brochure.pdf",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/IBMS-Thumbnail.jpg",
			},
			{
				title: "Financial App with MLM",
				description: "Customer Mobile App, Admin Back-office Portal",
				videoUrl: "",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/Financial-app-Thumbnail.jpg",
			},
			{
				title: "Super-app",
				description: "Mobile App, Customer Back-office Portal, Admin Back-office Portal, SFTP",
				videoUrl: "http://cdn.directintegrate.com/directintegrate/media/video/ATF_Super-app.mp4",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/Super-app-Thumbnail.jpg",
			},
			{
				title: "Task & Project Management",
				description: "Customer Web",
				videoUrl: "https://cdn.directintegrate.com/directintegrate/media/video/ATF-Task%20Management-Platform-Video.mp4",
				link: "https://media.directintegrate.com/directintegrate/cms/brochure/ATF-Workflow-Management-Platform-Brochure.pdf",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/TaskProject-Thumbnail.jpg",
			},
			{
				title: "InsureBridge – Motor Insurance Edition",
				description: "Open API, Customer Web",
				videoUrl: "",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/InsureBridge-Thumbnail.jpg",
			},
			{
				title: "e-Ticketing Solution (Mobile Responsive)",
				description: "Customer Web, Staff Portal, Admin Back-office Portal",
				videoUrl: "http://cdn.directintegrate.com/directintegrate/media/video/ATF_E-Ticketing-Solution.mp4",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/E-Ticket-Thumbnail.jpg",
			},
			{
				title: "Loyalty App",
				description: "Customer Mobile App, Admin Back-office Portal",
				videoUrl: "",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/Loyalty-app-Thumbnail.jpg",
			},
			{
				title: "SanctionGuard",
				description: "Open API",
				videoUrl: "http://cdn.directintegrate.com/directintegrate/media/video/ATF-SanctionGuard.mp4",
				link: "https://media.directintegrate.com/directintegrate/cms/brochure/ATF-Sanction-Flyer.pdf",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/SanctionGuard-Thumbnail.jpg",
			},
			{
				title: "Loan Onboarding System",
				description: "Customer Mobile App, Admin Back-office Portal",
				videoUrl: "",
				link: "https://media.directintegrate.com/directintegrate/cms/brochure/ATF-Microloan-Brochure.pdf",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/Loan-Onboarding-Thumbnail.jpg",
			},
			{
				title: "HR Portal",
				description: "Staff Portal, Admin Back-office Portal",
				videoUrl: "http://cdn.directintegrate.com/directintegrate/media/video/ATF_HRMS.mp4",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/HR-Portal-Thumbnail.jpg",
			},
			{
				title: "Test Automation Framework",
				description: "Automation Framework Base (exclusive incremental module coverage)",
				videoUrl: "",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/Test_Automation-Thumbnail.jpg",
			},
		];
	}, []);

	const totalPageNumber = Math.ceil(content.length / 6);
	const displayItems = isMobileView ? content.slice(currentPage * 6, (currentPage + 1) * 6) : content;

	const onHandleNext = useCallback(() => {
		setCurrentPage((prev) => (prev + 1) % totalPageNumber);
	}, [totalPageNumber]);

	const onHandleBack = useCallback(() => {
		setCurrentPage((prev) => (prev - 1 + totalPageNumber) % totalPageNumber);
	}, [totalPageNumber]);

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, [currentPage]);

	return (
		<>
			<SEO title={seoData.title} description={seoData.description} keywords={seoData.keywords} image="/images/atf-solutions-og.jpg" canonical={canonical} lang={lang} alternateLanguages={alternateLanguages} />

			{/* Service Structured Data */}
			<StructuredData
				type="Product"
				data={{
					"@context": "https://schema.org",
					"@type": "Service",
					serviceType: "Digital Transformation Services",
					provider: {
						"@type": "Organization",
						name: seoConfig.company.legalName,
						url: seoConfig.siteUrl,
					},
					areaServed: {
						"@type": "Country",
						name: ["Malaysia", "Thailand", "Global"],
					},
					hasOfferCatalog: {
						"@type": "OfferCatalog",
						name: "Digital Transformation Solutions",
						itemListElement: [
							{
								"@type": "Offer",
								itemOffered: {
									"@type": "Service",
									name: "Core Banking Solutions",
									description: "End-to-end digital banking system development and implementation",
								},
							},
							{
								"@type": "Offer",
								itemOffered: {
									"@type": "Service",
									name: "Insurance Technology Solutions",
									description: "Digital transformation for insurance companies with API integration",
								},
							},
							{
								"@type": "Offer",
								itemOffered: {
									"@type": "Service",
									name: "Custom Software Development",
									description: "Full-stack development with React and modern technologies",
								},
							},
						],
					},
				}}
			/>

			{/* Breadcrumb Structured Data */}
			<StructuredData
				type="BreadcrumbList"
				data={{
					itemListElement: [
						{
							"@type": "ListItem",
							position: 1,
							name: "Home",
							item: seoConfig.siteUrl,
						},
						{
							"@type": "ListItem",
							position: 2,
							name: lang === "th" ? "โซลูชันของเรา" : "Our Solutions",
							item: canonical,
						},
					],
				}}
			/>

			{/* Your page content */}
			<div className="page-products">
				<div className="products">
					<AppNavbar hideNavBar />

					<HeaderCard backgroundImage={headerImage} title="PRODUCT LISTING" />

					<div className="products__wrapper">
						<div className="products__container">
							{displayItems?.map((o, i) => (
								<div className="products__box" key={i}>
									<AppProductCard image={o.image} title={o.title} description={o.description} link={o.link} key={i} videoUrl={o.videoUrl} />
								</div>
							))}
						</div>
						{isMobileView && (
							<div className="products__mobile-pagination">
								<AppPagination totalPageNumber={totalPageNumber} currentPage={currentPage} onHandleNext={onHandleNext} onHandleBack={onHandleBack} />
							</div>
						)}
					</div>

					<AppFooter hideInfo />
				</div>
			</div>
		</>
	);
};

export default PageProducts;
